import React, { useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import './login.css'; // reuse the same styles as Login

function ResetPassword() {
  const { token } = useParams(); // Get reset token from URL
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  // Each field toggles on its own — the two are compared, so revealing one
  // should not reveal the other.
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    // 🔐 Minimum length check
    if (password.length < 4) {
      setError('Password must be at least 4 characters long');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const response = await axios.post(`/api/login/reset-password/${token}`, { password });
      setMessage(response.data.message || 'Password updated successfully.');
      setError('');

      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      setError(
        error.response?.data?.message || 'An error occurred. Please try again.'
      );
    }
  };

  return (
    <div className="portal-login-page">
      <div className="portal-login-container">
        <div className="portal-login-card">
          <div
            className="portal-login-logo-wrapper"
            onClick={() => navigate('/login')}
            style={{ cursor: 'pointer' }}
          >
            <img
              src="/logo.png"
              alt="Holiday Home Cleaning"
              className="portal-login-logo"
            />
          </div>

          <h1 className="portal-login-title">Set New Password</h1>
          <p className="portal-login-subtitle">
            Choose a strong password to secure your account.
          </p>

          <form onSubmit={handleResetPassword} className="portal-login-form">
            <div className="portal-login-form-group">
              <label className="portal-login-label">New Password</label>
              <div className="portal-login-password-wrap">
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter new password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="portal-login-input"
                />
                {/* type="button" — otherwise it submits the reset form. */}
                <button
                  type="button"
                  className="portal-login-password-toggle"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                  title={showPassword ? 'Hide password' : 'Show password'}
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
              </div>
            </div>

            <div className="portal-login-form-group">
              <label className="portal-login-label">Confirm New Password</label>
              <div className="portal-login-password-wrap">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  placeholder="Re-enter new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  className="portal-login-input"
                />
                <button
                  type="button"
                  className="portal-login-password-toggle"
                  onClick={() => setShowConfirmPassword((v) => !v)}
                  aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
                  title={showConfirmPassword ? 'Hide password' : 'Show password'}
                >
                  <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                </button>
              </div>
            </div>

            <button type="submit" className="portal-login-button">
              Reset Password
            </button>

            {message && (
              <p className="portal-login-success-message">
                {message}
              </p>
            )}
            {error && (
              <p className="portal-login-error-message">
                {error}
              </p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
